import axios from "axios";
import { API_URL } from "../../../setup/config/env";
export const createRole = async (roleData) => {
    try {
        const response = await axios.post(`${API_URL}/api/roles/create`, roleData);
        return response.data;
    } catch (error) {
        console.error("Error creating role:", error);
        throw error;
    }
};

export const updateRole = async (id, roleData) => {
    try {
        const response = await axios.post(`${API_URL}/api/roles/update/${id}`, roleData);
        return response.data;
    } catch (error) {
        console.error("Error updating role:", error);
        throw error;
    }
};

export const deleteRole = async (id) => {
    try {
        const response = await axios.post(`${API_URL}/api/roles/delete/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting role:", error);
        throw error;
    }
};

export const assignRoleToUser = async (userId, roleId) => {
    try {
        const response = await axios.post(`${API_URL}/api/roles/assign`, {
            userId,
            roleId
        });
        return response.data;
    } catch (error) {
        console.error("Error assigning role:", error);
        throw error;
    }
};
export const createAdminUser = async (adminData) => {
    try {
        const response = await axios.post(`${API_URL}/api/createAdminUser`, adminData);
        return response.data;
    } catch (error) {
        console.error("Error creating admin:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updateAdminStatus = async (adminId, updateType) => {
    try {
        const response = await axios.post(`${API_URL}/api/publish/admin`, {
            adminId, updateType
        });
        return response.data;
    } catch (error) {
        console.error("Error publishing admin:", error);
        throw error;
    }
};

export const updateAdminUser = async (adminId, adminData) => {
    try {
        const response = await axios.put(`${API_URL}/api/updateAdminUser/${adminId}`, adminData);
        return response.data;
    } catch (error) {
        console.error("Error updating admin:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};
